import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from './pages/Home';
import Services from './pages/Services';
import FAQ from './pages/FAQ';
import Estimation from './pages/Estimation';
import EstimationConfirmation from './pages/EstimationConfirmation';
import AdminLogin from './pages/AdminLogin';
import AdminLeads from './pages/AdminLeads';
import CityPage from './pages/CityPage';
import MentionsLegales from './pages/MentionsLegales';
import CGV from './pages/CGV';
import NosVilles from './pages/NosVilles';
import CransMontanaGestion from './pages/CransMontanaGestion';
import LausanneGestion from './pages/LausanneGestion';
import MontreuxGestion from './pages/MontreuxGestion';
import GeneveGestion from './pages/GeneveGestion';
import VerbierGestion from './pages/VerbierGestion';
import NeuchatelGestion from './pages/NeuchatelGestion';
import VillarsGestion from './pages/VillarsGestion';
import YverdonGestion from './pages/YverdonGestion';
import FribourgGestion from './pages/FribourgGestion';
import VeveyGestion from './pages/VeveyGestion';
import SionGestion from './pages/SionGestion';
import NyonGestion from './pages/NyonGestion';
import MorgesGestion from './pages/MorgesGestion';
import Blog from './pages/Blog';
import AvantagesLocationSaisonniere from './pages/AvantagesLocationSaisonniere';
import EstimationImmobiliereLocation from './pages/EstimationImmobiliereLocation';
import FiscaliteLocationSaisonniere from './pages/FiscaliteLocationSaisonniere';
import LocationSaisonniereVsLongueDuree from './pages/LocationSaisonniereVsLongueDuree';
import PhotosAirbnbProfessionnelles from './pages/PhotosAirbnbProfessionnelles';
import ConciergeriePourquoiDeleguer from './pages/ConciergeriePourquoiDeleguer';
import PricingDynamiqueAirbnbSuisse from './pages/PricingDynamiqueAirbnbSuisse';
import InvestissementLocatif7Erreurs from './pages/InvestissementLocatif7Erreurs';
import CalculRentabiliteAirbnbSuisse from './pages/CalculRentabiliteAirbnbSuisse';
import ReglementationAirbnbSuisse2025 from './pages/ReglementationAirbnbSuisse2025';
import TvaLocationSaisonniereSuisse from './pages/TvaLocationSaisonniereSuisse';
import TaxeSejourAirbnbSuisse from './pages/TaxeSejourAirbnbSuisse';
import DeductionsFiscalesAirbnbSuisse from './pages/DeductionsFiscalesAirbnbSuisse';
import AlgorithmeAirbnb2025 from './pages/AlgorithmeAirbnb2025';
import SuperHostAirbnbGuideComplet from './pages/SuperHostAirbnbGuideComplet';
import DescriptionAirbnbOptimisee from './pages/DescriptionAirbnbOptimisee';
import MontreuxJazz2025Airbnb from './pages/MontreuxJazz2025Airbnb';
import './App.css';

// Loading fallback (kept for potential future use)
const PageLoader = () => (
  <div className="min-h-screen bg-[#F5F3EF] flex items-center justify-center">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-[#8A9474] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-[#4A4A4A] text-sm">Chargement...</p>
    </div>
  </div>
);

import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/villes/:slug" element={<CityPage />} />
          <Route path="/estimation" element={<Estimation />} />
          <Route path="/estimation/confirmation" element={<EstimationConfirmation />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/legal/mentions" element={<MentionsLegales />} />
          <Route path="/legal/cgv" element={<CGV />} />
          <Route path="/nos-villes" element={<NosVilles />} />
          <Route path="/gestion-locative/crans-montana" element={<CransMontanaGestion />} />
          <Route path="/gestion-locative/lausanne" element={<LausanneGestion />} />
          <Route path="/gestion-locative/montreux" element={<MontreuxGestion />} />
          <Route path="/gestion-locative/geneve" element={<GeneveGestion />} />
          <Route path="/gestion-locative/verbier" element={<VerbierGestion />} />
          <Route path="/gestion-locative/neuchatel" element={<NeuchatelGestion />} />
          <Route path="/gestion-locative/villars" element={<VillarsGestion />} />
          <Route path="/gestion-locative/yverdon-les-bains" element={<YverdonGestion />} />
          <Route path="/gestion-locative/fribourg" element={<FribourgGestion />} />
          <Route path="/gestion-locative/vevey" element={<VeveyGestion />} />
          <Route path="/gestion-locative/sion" element={<SionGestion />} />
          <Route path="/gestion-locative/nyon" element={<NyonGestion />} />
          <Route path="/gestion-locative/morges" element={<MorgesGestion />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/avantages-location-saisonniere" element={<AvantagesLocationSaisonniere />} />
          <Route path="/blog/estimation-immobiliere-location-saisonniere" element={<EstimationImmobiliereLocation />} />
          <Route path="/blog/fiscalite-location-saisonniere-suisse" element={<FiscaliteLocationSaisonniere />} />
          <Route path="/blog/location-saisonniere-vs-longue-duree" element={<LocationSaisonniereVsLongueDuree />} />
          <Route path="/blog/photos-airbnb-professionnelles" element={<PhotosAirbnbProfessionnelles />} />
          <Route path="/blog/conciergerie-airbnb-pourquoi-deleguer" element={<ConciergeriePourquoiDeleguer />} />
          <Route path="/blog/pricing-dynamique-airbnb-suisse" element={<PricingDynamiqueAirbnbSuisse />} />
          <Route path="/blog/investissement-locatif-airbnb-7-erreurs" element={<InvestissementLocatif7Erreurs />} />
          <Route path="/blog/calcul-rentabilite-airbnb-suisse" element={<CalculRentabiliteAirbnbSuisse />} />
          <Route path="/blog/reglementation-airbnb-suisse-2025" element={<ReglementationAirbnbSuisse2025 />} />
          <Route path="/blog/tva-location-saisonniere-suisse" element={<TvaLocationSaisonniereSuisse />} />
          <Route path="/blog/taxe-sejour-airbnb-suisse" element={<TaxeSejourAirbnbSuisse />} />
          <Route path="/blog/deductions-fiscales-airbnb-suisse" element={<DeductionsFiscalesAirbnbSuisse />} />
          <Route path="/blog/algorithme-airbnb-2025" element={<AlgorithmeAirbnb2025 />} />
          <Route path="/blog/super-host-airbnb-guide-complet" element={<SuperHostAirbnbGuideComplet />} />
          <Route path="/blog/description-airbnb-optimisee" element={<DescriptionAirbnbOptimisee />} />
          <Route path="/blog/montreux-jazz-festival-2025-airbnb" element={<MontreuxJazz2025Airbnb />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
